import { render } from "./AdminWfhDetailsPage.vue?vue&type=template&id=4c23af25"
import script from "./AdminWfhDetailsPage.vue?vue&type=script&lang=js"
export * from "./AdminWfhDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__